import { createApp, h } from 'vue'
import { App, plugin } from '@inertiajs/inertia-vue3'
import VueMeta from 'vue-meta'
import { InertiaProgress } from '@inertiajs/progress'
import LoadScript from "vue-plugin-load-script"
import {__, trans, setLocale, getLocale, transChoice, MaticeLocalizationConfig, locales} from 'matice'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import Toaster from "@meforma/vue-toaster";
import VuePapaParse from 'vue-papa-parse'

library.add(fas, far, fab);
if(localStorage.getItem('locale')){
  setLocale(localStorage.getItem('locale'));
}
//
// Vue.config.productionTip = false
// Vue.mixin({ methods: { route: window.route } })
// Vue.use(PortalVue)
// Vue.use(VueMeta)
//
// InertiaProgress.init()
//
// createInertiaApp({
//   resolve: name => require(`./Pages/${name}`),
//   setup({ el, app, props }) {
//     new Vue({
//       metaInfo: {
//         titleTemplate: title => (title ? `${title} - Your Race plan` : 'Your Race plan'),
//       },
//       render: h => h(app, props),
//     }).$mount(el)
//   },
// })

InertiaProgress.init()
const el = document.getElementById('app')
const app = createApp({
  render: () => h(App, {
    initialPage: JSON.parse(el.dataset.page),
    resolveComponent: name => import(`./Pages/${name}`).then(module => module.default),
  })
})
  .mixin({
    methods: {
      route: (name, params, absolute) => route(name, params, absolute, Ziggy),
      $trans: __,
      $__: __,
      $transChoice: transChoice,
      // The current locale
      $locale() {
        return getLocale()
      },
      // A listing of the available locales
      $locales() {
        return locales()
      },
    },
  });
app.component('font-awesome-icon', FontAwesomeIcon);
app.use(plugin, VueMeta, LoadScript);
app.use(Toaster, {
  // One of the options
  position: "top-right",
});
app.use(VuePapaParse);
app.mount(el);
